import React, { useState } from 'react';
import './Admin.css';
import { useLoginWithUsernameAndPasswordMutation } from '../../api/client';

interface LoginProps {
  onLogin: (token: string) => void;
}

export function Login({ onLogin }: LoginProps) {
  const [username, setUsername] = useState('');
  const [password, setPassword] = useState('');
  const [loginMutation, { isLoading, error }] = useLoginWithUsernameAndPasswordMutation();

  const handleSubmit = async (e: React.FormEvent<HTMLFormElement>) => {
    e.preventDefault();
    try {
      const result = await loginMutation({
        username,
        password,
      }).unwrap();

      onLogin(result.access_token);
    } catch (error) {
      console.error('Login failed:', error);
    }
  };

  return (
    <div className="admin-root">
      <div className="admin-login-page">
        <div className="admin-login-card">
          <div className="admin-login-header">
            <div className="admin-login-logo">Hereabout Admin</div>
            <div className="admin-login-subtitle">
              Sign in to access the admin dashboard
            </div>
          </div>

          <form onSubmit={handleSubmit}>
            <div className="admin-form-group">
              <label className="admin-form-label" htmlFor="username">
                Username
              </label>
              <input
                id="username"
                type="text"
                className="admin-form-input"
                placeholder="Enter your username"
                value={username}
                onChange={(e) => setUsername(e.target.value)}
                required
                autoComplete="username"
              />
            </div>

            <div className="admin-form-group">
              <label className="admin-form-label" htmlFor="password">
                Password
              </label>
              <input
                id="password"
                type="password"
                className="admin-form-input"
                placeholder="Enter your password"
                value={password}
                onChange={(e) => setPassword(e.target.value)}
                required
                autoComplete="current-password"
              />
            </div>

            <button
              type="submit"
              className="admin-login-btn"
              disabled={isLoading}
            >
              {isLoading ? 'Signing in...' : 'Sign in'}
            </button>

            {error && (
              <div className="admin-login-error">
                Login failed. Please check your credentials.
              </div>
            )}
          </form>
        </div>
      </div>
    </div>
  );
}

export default Login;
